// extracted by mini-css-extract-plugin
export default {"home_wrap":"Home_home_wrap__z21Z7"};